export const Reveal = ({ children, delay = 0, className = "" }) => (
  <div className={`reveal ${className}`} style={delay ? { animationDelay: `${delay}s` } : undefined}>
    {children}
  </div>
);

export const SectionHeading = ({ eyebrow, title, lead, id, testId, editorial = false }) => (
  <div className="max-w-3xl">
    {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
    <h2 id={id} data-testid={testId} className={editorial ? "h-editorial" : "h-section"}>
      {title}
    </h2>
    {lead && <p className="lead mt-5 max-w-2xl">{lead}</p>}
  </div>
);

const KIND_STYLE = {
  "Laboratory analysis": "bg-aqua",
  "On-site monitoring": "bg-lilac",
  "On-site screening": "bg-lilac",
  "Report + conversation": "bg-mint",
};

export const MethodTag = ({ kind }) => (
  <span className={`inline-flex items-center gap-1.5 rounded px-2 py-0.5 mono font-medium text-forest ${KIND_STYLE[kind] || "bg-mint"}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-forest" aria-hidden />
    {kind}
  </span>
);
